<style lang="postcss">
  .spinner {
    display: inline-block;
    width: var(--ubilabs-loading-spinner-size);
    height: var(--ubilabs-loading-spinner-size);
    border-radius: 0.5em;
    border: max(
        var(--ubilabs-loading-spinner-width),
        var(--ubilabs-loading-spinner-min-width)
      )
      solid var(--ubilabs-loading-spinner-background-color);
    border-top-color: var(--ubilabs-loading-spinner-color);
    animation: spinning 1s infinite cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  @keyframes spinning {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>

<div class="spinner {$$props.class}" />
